export const SET_CUSTOMER_OPTIONS = "SET_CUSTOMER_OPTIONS";
export const VALIDATE_INVITEE_STARTED = "VALIDATE_INVITEE_STARTED";
export const VALIDATE_INVITEE_SUCCEEDED = "VALIDATE_INVITEE_SUCCEEDED";
export const VALIDATE_INVITEE_FAILED = "VALIDATE_INVITEE_FAILED";
export const FETCH_INVITEE_STARTED = "FETCH_INVITEE_STARTED";
export const FETCH_INVITEE_SUCCEEDED = "FETCH_INVITEE_SUCCEEDED";
export const FETCH_INVITEE_FAILED = "FETCH_INVITEE_FAILED";
export const SET_USER_INFO = "SET_USER_INFO";
export const CREATE_SIGNATORY_STARTED = "CREATE_SIGNATORY_STARTED";
export const CREATE_SIGNATORY_SUCEEDED = "CREATE_SIGNATORY_SUCEEDED";
export const CREATE_SIGNATORY_FAILED = "CREATE_SIGNATORY_FAILED";
export const SET_SIGNATORY_INFO = "SET_SIGNATORY_INFO";
export const SET_NEXT_OF_KIN_INFO = "SET_NEXT_OF_KIN_INFO";
export const UPLOAD_BILL_STARTED = "UPLOAD_BILL_STARTED";
export const UPLOAD_BILL_SUCCEEEDED = "UPLOAD_BILL_SUCCEEEDED";
export const UPLOAD_BILL_FAILED = "UPLOAD_BILL_FAILED";
export const SET_CONFIRM_INFO = "SET_CONFIRM_INFO";
export const SET_NOK_RELATIONSHIP = "SET_NOK_RELATIONSHIP";
export const CREATE_NEW_PASSWORD = "CREATE_NEW_PASSWORD"
export const SET_DATE_OF_BIRTH = "SET_DATE_OF_BIRTH";
export const RESET_LGA = "RESET_LGA";